import { useEffect, useState } from 'react';

const FIRST_HEIGHT = 200;
const useInfiniteScroll = (rootViewPort: React.RefObject<HTMLElement> | null) => {
  const [isLoadMore, setIsLoadMore] = useState(false);

  useEffect(() => {
    if (!rootViewPort?.current) return;

    function handleScroll() {
      if (!rootViewPort?.current) return;
      const { scrollHeight } = rootViewPort.current;
      const { scrollTop } = rootViewPort.current;
      const height = rootViewPort.current.clientHeight;
      const isBottom = scrollHeight - height - scrollTop < FIRST_HEIGHT;

      if (isBottom) {
        setIsLoadMore(true);
      } else {
        setIsLoadMore(false);
      }
    }

    rootViewPort.current.addEventListener('scroll', handleScroll);

    return () => {
      rootViewPort.current?.removeEventListener('scroll', handleScroll);
    };
  }, [rootViewPort]);

  return { isLoadMore };
};

export default useInfiniteScroll;
